import '../styles/Home.css';
import { Link } from 'react-router-dom';
import Carousels from './Carousel';
const Home = () => {
    return (
        <div className=''>
        <div>
            <div className="card border-0" style={{"width": "18rem"}}>
                <img src="./home/anzuchan.png" className="card-img-top anzu" alt="anime poster"/>
                <div className="card-body">
                <h5 className="card-title">Welcome to Anime Quiz!</h5>
                <p className="card-text">Explore the site</p>
                <p className="card-text">Take a Quiz</p>
                <Link to="/reincarnation" className="btn">Start Quiz</Link>
            </div>
            <div className='card border-0'>
                <Carousels/>
            </div>
        </div>
        </div>
        </div>
    )
}

export default Home;
